import { AppState, FeedPageAppState } from '../../initialStateRegistration';
import { FeedPageSectionNames } from './feedPage.reducer';

export const getFeedPage = (state: AppState) => (state as FeedPageAppState).template;

export const getSectionDataByKey = (key: FeedPageSectionNames) => (state: AppState) => getFeedPage(state)[key];

export const getSectionArticlesByKey = (key: FeedPageSectionNames) => (state: AppState) => getFeedPage(state)[key].articles;

export const getSectionDisplayNameByKey = (key: FeedPageSectionNames) => (state: AppState) => getFeedPage(state)[key].displayName;

export const getSectionTextByKey = (key: FeedPageSectionNames) => (state: AppState) => getFeedPage(state)[key].text;

export const getSectionNextByKey = (key: FeedPageSectionNames) => (state: AppState) => getFeedPage(state)[key].next;
